import { render, staticRenderFns } from "./ShipmentRecordExtraction.vue?vue&type=template&id=0e90b1a1&scoped=true"
import script from "./ShipmentRecordExtraction.vue?vue&type=script&lang=js"
export * from "./ShipmentRecordExtraction.vue?vue&type=script&lang=js"
import style0 from "./ShipmentRecordExtraction.vue?vue&type=style&index=0&id=0e90b1a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e90b1a1",
  null
  
)

export default component.exports